import React from "react";
import { useTranslation } from "react-i18next";
import {
  translateColumnOverflowHintMessage,
  translateRowColumnOverflowHintMessage,
} from "../domain/labels";

export function EmailBuilderColumnOverflowHint() {
  const { t } = useTranslation();

  return (
    <p className="email-builder-settings-field-hint">
      {translateColumnOverflowHintMessage(t)}
    </p>
  );
}

export function EmailBuilderRowColumnOverflowHint() {
  const { t } = useTranslation();

  return (
    <p className="email-builder-settings-field-hint">
      {translateRowColumnOverflowHintMessage(t)}
    </p>
  );
}
